document.addEventListener('alpine:init', function () {
    Alpine.data('togetherAsOne', function () {
        var animationId = null;
        return {
            init: function () {
                var topRow = this.$refs.topRow;
                var bottomRow = this.$refs.bottomRow;
                if (!topRow || !bottomRow)
                    return;
                // Respect prefers-reduced-motion — skip animations entirely.
                var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
                if (motionQuery.matches)
                    return;
                // Stop if user changes preference mid-session
                motionQuery.addEventListener('change', function (e) {
                    if (e.matches && animationId !== null) {
                        cancelAnimationFrame(animationId);
                        animationId = null;
                        topRow.style.transform = '';
                        bottomRow.style.transform = '';
                    }
                });
                var speed = 0.5; // pixels per frame
                var topOffset = 0;
                var bottomOffset = 0;
                // Get the width of one set of images (half the duplicated content)
                var getResetPoint = function (row) { return row.scrollWidth / 2; };
                function animate() {
                    var topReset = getResetPoint(topRow);
                    var bottomReset = getResetPoint(bottomRow);
                    topOffset -= speed;
                    bottomOffset += speed;
                    // Reset seamlessly when one full set has scrolled past
                    if (Math.abs(topOffset) >= topReset)
                        topOffset = 0;
                    if (bottomOffset >= bottomReset)
                        bottomOffset = 0;
                    topRow.style.transform = "translateX(".concat(topOffset, "px)");
                    bottomRow.style.transform = "translateX(".concat(bottomOffset - getResetPoint(bottomRow), "px)");
                    animationId = requestAnimationFrame(animate);
                }
                // Start bottom row offset so it scrolls in from the right
                bottomOffset = 0;
                bottomRow.style.transform = "translateX(".concat(-getResetPoint(bottomRow), "px)");
                animationId = requestAnimationFrame(animate);
            },
            destroy: function () {
                if (animationId !== null) {
                    cancelAnimationFrame(animationId);
                    animationId = null;
                }
            },
        };
    });
});
